import React from 'react';
import EditableInput from '../../common/editableInput/EditableInput';

const ProfileInformation = ({ customer, ...rest }) => {
  return (
    <div>
      <h5 className="text-xl mb-4 font-medium">General Settings</h5>
      <EditableInput
        inputName="first_name"
        inputType="text"
        label="First Name"
        value={customer.first_name}
        placeholder="First Name"
        regex={/^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{1,}$/}
        validationMessage="Name should not contain numbers or special characters."
      />
      <EditableInput
        inputName="last_name"
        inputType="text"
        label="Last Name"
        value={customer.last_name}
        placeholder="Last Name"
        regex={/^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{1,}$/}
        validationMessage="Name should not contain numbers or special characters."
      />
      <EditableInput
        inputName="phone"
        inputType="tel"
        label="Phone"
        value={customer.phone}
        placeholder={
          customer.phone === '' || customer.phone === 'undefined'
            ? 'Phone Number'
            : customer.phone
        }
        regex={/(^$|^[0-9]{3}-[0-9]{3}-[0-9]{4}$)/}
        validationMessage="Enter valid phone number. (xxx-xxx-xxxx)"
      />
      <h5 className="text-xl mb-4 mt-8 font-medium">Login Details</h5>
	  <p className="text-base mb-4 font-light"><em>To edit the email address associated with your account, please contact Customer Service at 585-442-7200 or use the chat icon on the left side of the screen.</em></p>
      <EditableInput
        inputName="password"
        inputType="password"
        label="Password"
        placeholder="New Password"
      />
    </div>
  );
};

export default ProfileInformation;
